
import {onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import {Helpers} from "Helpers/helpers";
import * as scrollama from "scrollama";
import { throttle } from 'throttle-debounce';

export default {
	name: "SectionNavigation",
	props: {
		groupBy: {
			type: String,
			default: ''
		},
		productTypes: {
			type: Array,
			default: () => [],
		},
		translations: {
			type: Object,
			default: {},
		}
	},
	setup(props) {
		const store = useStore();
		const staticSections = ref([]);
		const activeTab = ref('');
		const mobileMenuOpen = ref(false);
		const isMobile = ref(false);

		const scrollDown = (e) => {
			e.preventDefault();
			const targetDiv = document.getElementById(e.target.getAttribute('data-target'));
			targetDiv.scrollIntoView({ behavior: 'smooth'});
			let stickyBar:HTMLElement = document.querySelector('.tab-bar__sticky');
			window.scrollTo(0, targetDiv.getBoundingClientRect().top + window.pageYOffset - stickyBar.offsetHeight);

			if(isMobile && mobileMenuOpen) {
				mobileMenuOpen.value = !mobileMenuOpen.value;
			}
		};

		const addStaticContentSections = () => {
			let sections = document.querySelectorAll('.container-as-nav-item');
			let sectionArray =  Array.from(sections);

			sectionArray.forEach(section => {
				let label = section.getAttribute('data-placeholder-label');
				if(label) {
					let uniqueLabel = Helpers.ensureUnique(Helpers.slugify(label));
					section.setAttribute('id', uniqueLabel);
					staticSections.value.push({title: label, slug: uniqueLabel, height: section.clientHeight });
				}
			});
		};

		const initScrollSpy = () => {
			// initialize the scrollama (or grab a reference if one already exists - this seems to be a Singleton)
			let scrollSpyHandler:any = scrollama();
			let containerItems:NodeListOf<Element> = document.querySelectorAll('.container-as-nav-item');
			let handleStepEnter = (response) => {

				//when an element enters into the scollama view range, get the element's data-section attribute value
				let theSection = response.element.getAttribute('id');

				//then we find the matching navigation item whose data-target matches data-section value
				//we just stored and add a .state-active class
				let $newNavItem = document.querySelector(`a[data-target="${theSection}"]`);

				if ($newNavItem) {
					let tabBarLinks = document.querySelectorAll('.tab-bar__link');
					// Remove state-active from any currently active section-nav triggers
					tabBarLinks.forEach((tabBarLink) => {
						tabBarLink.classList.remove('state-active');
					});

					$newNavItem.classList.add('state-active');
				}
			}

			if (containerItems.length) {
				scrollSpyHandler.setup({
					step: '.container-as-nav-item',
					offset: 0.25
				}).onStepEnter(handleStepEnter)
					.onStepProgress(function () {
						console.log(arguments);
					});
			}

			window.addEventListener('resize', function() {
				scrollSpyHandler.resize();
			});
		}

		const observeActiveTab = () => {
			const linkElements = document.querySelectorAll('.tab-bar__link');

			// Iterate over each link element
			linkElements.forEach((linkElement) => {
				const observer = new MutationObserver((mutationsList) => {
					for (const mutation of mutationsList) {
						if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
							if(linkElement.classList.contains('state-active')) {
								activeTab.value = linkElement.innerHTML
							}
						}
					}
				});

				observer.observe(linkElement, { attributes: true });
			});
		};

		const toggleMenu = () => {
			mobileMenuOpen.value = !mobileMenuOpen.value;
		}

		const setMobileActive = () => {
			setTimeout(() => {
				let theActiveTab = document.querySelector('.tab-bar__link.state-active');
				//console.log('testingthisthing');
				activeTab.value = theActiveTab ? document.querySelector('.tab-bar__link.state-active').innerHTML : '';
			}, 500)
		};

		const checkWidth = () => {
			isMobile.value = window.innerWidth < 992;
			if(isMobile.value) {
				mobileMenuOpen.value = false;
			}
		};


		onMounted(() => {
			window.addEventListener('load', () => {
				addStaticContentSections();
				initScrollSpy();
				observeActiveTab();
				setMobileActive();
			});
			checkWidth();
			window.addEventListener(
				'resize',
				throttle(100, false, () => {
					checkWidth();
				})
			);
		});

		return {
			store,
			scrollDown,
			staticSections,
			addStaticContentSections,
			checkWidth,
			toggleMenu,
			activeTab,
			mobileMenuOpen,
			isMobile,
			setMobileActive,
		}
	}
}
